var map = {
	"./countdata.png": 110,
	"./leadscore.png": 111,
	"./news.gif": 112,
	"./project-04.png": 113,
	"./project-05.png": 114,
	"./reddit_etl.png": 115,
	"./sparnord.png": 116,
	"./voice.gif": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;